module.exports = __webpack_public_path__ + "img/promotion.d46c1158.png";